// The text a tech copies or shares once the AI has made its call: the unit,
// the complaint, the readings actually taken (the "Reading: …" sentences the
// composer prepends to answers), and the diagnosis without app markers.
// Copy and Share in Troubleshoot.jsx both use it, so they never disagree.

import { isDiagnosis, stripDiagnosisLabel } from './diagnosis.js';
import { parseTurnContent } from '../../shared/turnMarkers.js';

/** Returns the summary text, or null when there is no diagnosis yet. */
export function buildDiagnosisSummary({ result, turns }) {
  const list = turns || [];
  const diagnosisTurn = [...list].reverse().find((t) => t.role === 'ai' && isDiagnosis(t.content));
  if (!diagnosisTurn) return null;

  const header = `${result?.brand_matched || result?.brand || ''} ${result?.appliance_type || ''} · ${result?.model_number || ''}`
    .replace(/\s+/g, ' ')
    .trim();
  const complaint = list.find((t) => t.role === 'tech')?.content?.trim();
  const readings = list
    .filter((t) => t.role === 'tech' && /^Reading:\s/.test(t.content || ''))
    .map((t) => `- ${t.content.replace(/^Reading:\s*/, '').trim()}`);
  const diagnosis = parseTurnContent(stripDiagnosisLabel(diagnosisTurn.content)).textOnly
    .replace(/[ \t]+\n/g, '\n')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();

  return [
    header,
    complaint ? `Complaint: ${complaint}` : null,
    readings.length ? `Readings:\n${readings.join('\n')}` : null,
    `Diagnosis: ${diagnosis}`,
  ].filter(Boolean).join('\n\n');
}
